import { objectfyArray } from "../helpers/objectfyArray";

const webStore = (state = {}, action) => {
  Object.freeze(state);
  let newState;
  switch (action.type) {
    case "SET_WEB_STORE":
      if (Array.isArray(action.storeItems)) {
        newState = {
          ...state,
          ...objectfyArray(action.storeItems),
          ["options"]: action.options,
        };
        return newState;
      } else {
        newState = {
          ...state,
          ...action.storeItems,
          ["options"]: action.options,
        };
        return newState;
      }

    case "SET_STORE_ITEMS":
      if (Array.isArray(action.storeItems)) {
        return objectfyArray(action.storeItems);
      } else {
        return action.storeItems;
      }

    default:
      return state;
  }
};

export default webStore;
